module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-3.55cd8c8a.jpg";